import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Copyright © 2024 Meigetsu / Crescent Engage. All rights reserved", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "東京都港区南青山２－２ ５Ｆ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "東京都公安委員会 30230071-000", -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}